import { Component, OnInit, ViewChild } from '@angular/core';
import { AveriasService } from '../servicios/averias.service';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter } from 'angular-slickgrid';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';


@Component({
    selector: 'app-consulta-usuarios-operador',
    templateUrl: './consulta-usuarios-operador.component.html',
    styleUrls: ['./consulta-usuarios-operador.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, NbIconModule, DropdownModule,
       MatCardModule, MatFormFieldModule, MatInputModule, AngularSlickgridModule, NbTabsetModule,
        MatDatepickerModule, MatNativeDateModule, NbSelectModule, NbTreeGridModule, SpinnerComponent, 
        MultiSelectModule, AgGridAngular],
    providers: [DatePipe],
})
export class ConsultaUsuariosOperadorComponent implements OnInit {
  idCliente: number;
  columnDefinitionsUsuarios: ColDef[];//Column[];
  gridOptionsUsuarios: GridOption;
  dataView: any;
  gridObj: any;
  angularGrid: AngularGridInstance;
  datasetUsuarios;
  showGrilla = false;
  showSpinner = false;
  showSpinnerEliminar:boolean =false;
  durationInSeconds = 3;
  deshabilitarExportUser = true;

  empresaSelected;
  perfilSelected;
  empresas = []
  perfiles = [];
  flagActivo = '1';
  optAct = [
    { value: '1', label: 'Activo' },
    { value: '0', label: 'No Activo' },
  ];
  dataParaEdit;
  usuarioAEliminar;
  userToChangePass;
  idOperador:number= 0;
  @ViewChild('grilla1') grilla1!: AgGridAngular;


  constructor(private servicioUsuarios: PerfilesUsuarioService, private svcAverias: AveriasService,
    private dateFormatter: DatePipe) { }

  ngOnInit(): void {
    this.idCliente = Number( localStorage.getItem("idCliente"));
    this.idOperador = Number( localStorage.getItem("idOperador"));
    this.formatoGrilla();
    this.llenarEmpresas()
    this.llenarPerfiles();
  }

  llenarEmpresas(){
    if (this.servicioUsuarios.GESTIONAR_USUARIOS){
      this.svcAverias.getOperadoresPorCliente(this.idCliente).subscribe( data => {
        let misEmpresas;
        this.empresas = [{value: 0, label: "Ninguna"}];
        misEmpresas = data;
        misEmpresas.forEach(e => {
          this.empresas.push({
            value: e.id,
            label: e.descripcion
          })
        });
      });
    }
    else{
      this.svcAverias.getOperadoresPorId(this.idOperador).subscribe( data => {
        let misEmpresas;
        this.empresas = [{value: 0, label: "Ninguna"}];
        misEmpresas = data;
        this.empresas.push({
          value: misEmpresas.id,
          label: misEmpresas.descripcion
        })
      });
    }
  }

  llenarPerfiles(){
    this.servicioUsuarios.getPerfiles().subscribe(data =>{
      let misPerfiles;
      this.perfiles = [{value: 0, label: "Ninguno"}];
      misPerfiles = data;
      misPerfiles.content.forEach(e => {     
        if (e.operador){
          this.perfiles.push({
            value: e.id,
            label: e.descripcion
          })
        }        
      });
    });
  }

  formatoGrilla(){
    this.gridOptionsUsuarios = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableFiltering: true,
      rowSelectionOptions: {selectActiveRow: false}
    };

    this.columnDefinitionsUsuarios = [
      { //id: 'username', 
        headerName: 'Nombre de Usuario', field: 'username', sortable: true, filter: true, floatingFilter: true, minWidth: 50},
      { //id: 'nombre', 
        headerName: 'Nombre', field: 'nombre', sortable: true, filter: true, floatingFilter: true, minWidth: 60},
      { //id: 'apellido', 
        headerName: 'Apellido', field: 'apellido', sortable: true, filter: true, floatingFilter: true, minWidth: 60},
      { //id: 'correoElectronico', 
        headerName: 'E-mail', field: 'correoElectronico', sortable: true, filter: true, floatingFilter: true, minWidth: 60},
      { //id: 'empresa', 
        headerName: 'Empresa', field: 'empresa', sortable: true, filter: true, floatingFilter: true, minWidth: 60},
      { //id: 'perfil', 
        headerName: 'Perfil', field: 'perfil', sortable: true, filter: true, floatingFilter: true, minWidth: 60}
    ];
  }

  exportToExcelUsuarios() {
    const rowData: any[] = [];
    const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();

    // Obtener solo las filas visibles (después de filtros y orden)
    this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
      if (node.data) {
        const filaFiltrada: any = {};
        columnasVisibles.forEach(col => {
          const campo = col.getColDef().field;
          if (campo) {
            filaFiltrada[campo] = node.data[campo];
          }
        });
        rowData.push(filaFiltrada);
      }
    });

    if (rowData.length === 0) {
      console.warn('No hay datos para exportar');
      return;
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Usuarios': worksheet },
      SheetNames: ['Usuarios']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    FileSaver.saveAs(blob, 'Usuarios_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
  }

  angularGridReady(angularGrid: AngularGridInstance){
    this.angularGrid = angularGrid;
    this.dataView = angularGrid.dataView;
    this.gridObj =  angularGrid.slickGrid
  }

  consultarUsuarios(){
    this.deshabilitarExportUser = true;
    let myDTO = {
      idPerfilUsuario: parseInt(this.perfilSelected) == 0 ? null : parseInt(this.perfilSelected),
      idCliente: this.idCliente,
      eliminado: this.flagActivo == '1' ? false : true,
      idOperador: parseInt(this.empresaSelected) == 0 ? null : parseInt(this.empresaSelected)
    }
    this.showSpinner = true;
    this.servicioUsuarios.getUsuariosOperador(myDTO).subscribe( data => {
      var operadores = data.body.filter(n=> n.operador.id !=null)
      if(data["status"] == 403 )
        alert("El usuario no tiene permisos.") 
      else if(data["status"] != 200)
        alert("Ocurrio un error al traer los datos.") 
      else
        this.prepararDatos(operadores)
    },erros => {
      this.showSpinner = false;
    })
  }

  prepararDatos(array){
    this.datasetUsuarios = [];
    if (array != undefined){
      array.forEach(e => {
        this.datasetUsuarios.push(
          {
            id: e.id,
            username: e.username,
            nombre: e.nombre,
            apellido: e.apellido,
            correoElectronico: e.correoElectronico,
            perfil: e.perfil.descripcion,
            perfilId: e.perfil.id,
            empresa: e.operador != null ? e.operador.descripcion : "",
            empresaId: e.operador != null ? e.operador.id : "",
            fechaAlta: e.fechaAlta,
            activo: e.activo == true? "SI": "NO",
            cliente: e.clientes.length > 0? e.clientes[0].descripcion : "",
            clienteId: e.clientes.length > 0? e.clientes[0].id : "",
            operador: e.operador != null ? e.operador.descripcion : "",
            operadorId: e.operador != null ? e.operador.id : "",
          }
        )
      });
      this.showGrilla = true;
      this.showSpinner = false;
      if(this.datasetUsuarios.length > 0){
        this.deshabilitarExportUser = false;
      }
    }else{
      alert("No se encontraron registros")
      this.showSpinner = false;
    }
  }

  
  onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
  }

}
